exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column[data-v-1403cc13] {\n  white-space: nowrap;\n}\n@media (max-width: 991px) {\n.columns[data-v-1403cc13]:not(.is-desktop) {\n    display: block !important;\n}\n.column[data-v-1403cc13] {\n    white-space: normal;\n}\n}\n@media (min-width: 992px) {\n.columns[data-v-1403cc13]:not(.is-desktop) {\n    display: flex;\n}\n}", ""]);

// exports
